<template>
    <div class="">
        <div>
            <img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/16.png" style="width: 100%" alt="">
        </div>
        <product-function/>
        <product-info productInfo="cicadaProductInfo" productProvince="cicadaProvince" />

        <div class="index-div-content   product-info-div-no-padding">
                <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                    <el-col :xs="24" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/17.png" style="width:100%"
                                                   alt=""></el-col>
                    <el-col :xs="24" :sm="12">
                        <div class="product-info-content">
                            <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                                <span>云台舵机摄像头水平垂直设计</span>
                            </h3>
                            <div class="robot-info-splice"></div>
                            <p class="margin-top-20">
                                机器人云台采用水平和垂直一体化设计，可以灵活调整焦距视距，拓宽数据采集视野范围，提高作业效率。
                            </p>
                        </div>

                    </el-col>
                </el-row>
                <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                    <el-col :xs="24" :sm="0"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/18.png" style="width:100%"
                                                   alt=""></el-col>
                    <el-col :xs="24" :sm="12">
                        <div class="product-info-content">
                            <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                                <span>4#角钢吊轨设计，重量最轻</span>
                            </h3>
                            <div class="robot-info-splice"></div>
                            <p class="margin-top-20">
                                机器人体积320x200x200mm，体重8.5KG，使用4#角钢轨道，具有体积更小、重量更轻、性能更稳、效果更明显、成本更低等优点。
                            </p></div>
                    </el-col>
                    <el-col :xs="0" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/18.png" style="width:100%"
                                                   alt=""></el-col>
                </el-row>
                <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                    <el-col :xs="24" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/3.png" style="width:100%"
                                                   alt=""></el-col>
                    <el-col :xs="24" :sm="12">
                        <div class="product-info-content">
                            <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                                <span>自主导航 自主定位</span>
                            </h3>
                            <div class="robot-info-splice"></div>
                            <p class="margin-top-20">
                                使用高精度电机里程计和RFID标签精准定位功能，自研底层智能导航算法技术，实现机器人全自主导航。
                            </p></div>
                    </el-col>

                </el-row>
                <el-row type="flex" justify="center" class="margin-top-20 background-white product-info-div-flex">
                    <el-col :xs="24" :sm="0" ><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/4.png" style="width:100%"
                                                   alt=""></el-col>
                    <el-col :xs="24" :sm="12">
                        <div class="product-info-content">
                            <h3 class="margin-bottom-20 margin-top-20  color-1B1B1B font-28 ">
                                <span>自主巡检 智能巡检</span>
                            </h3>
                            <div class="robot-info-splice"></div>
                            <p class="margin-top-20">
                                底层自研多种巡检模式，包括自主巡检、排班巡检、满电巡检多种巡检模式，满足不同场景的无人巡检功能。
                            </p></div>
                    </el-col>
                    <el-col :xs="0" :sm="12"><img src="../../../assets/MK体育 - MK(中国)一站式服务官方网站/product/info/cicada/4.png" style="width:100%"
                                                   alt=""></el-col>
                </el-row>
            </div>

        <div class=" background-white margin-top-20" >
            <div class="index-div-content" >
                <div class="  product-info-div-no-padding product-info-example ">

                    <h3 class="margin-bottom-10 center color-1B1B1B font-28 ">
                        <img src="../../../assets/img/1.png" width="31" alt=""> <span style="margin:0 20px">应用案例</span>
                        <img
                                src="../../../assets/img/2.png" width="31" alt="">
                    </h3>
                    <div id="maodian">
                        <el-row :gutter="20">
                            <el-col :xs="24" :sm="12">
                                <div>
                                    <video-component
                                            video-url="https://MK体育 - MK(中国)一站式服务官方网站-video.oss-cn-beijing.aliyuncs.com/video/05-%E6%A0%87%E5%87%86Cicada-%E8%BE%93%E7%85%A4%E5%BB%8A%E9%81%93-%E4%BC%98%E7%89%B9%E6%9D%A5-%E5%94%90%E5%B1%B1%E9%A6%96%E9%92%A2.MP4"/>
                                    <div class="video-content">案例1：唐山某钢厂标准Cicada机器人输煤廊道巡检</div>
                                </div>
                            </el-col>
                            <el-col :xs="24" :sm="12">
                                <div>

                                  
                                    <video-component1
                                            video-url="https://MK体育 - MK(中国)一站式服务官方网站-video.oss-cn-beijing.aliyuncs.com/video/08-%E6%A0%87%E5%87%86Cicada-%E5%8F%98%E7%94%B5%E6%89%80%E5%B7%A1%E6%A3%80-%E5%8D%83%E9%A2%90%E5%85%96%E7%9F%BF.mp4"/>
                                    <div class="video-content">案例2：金鸡滩某矿厂标准Cicada机器人变电所巡检</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div style="height: 20px"></div>
                </div>
            </div>

        </div>

    </div>


</template>

<script>
    import VideoComponent from "../../commom/VideoComponent";
    import VideoComponent1 from "../../commom/VideoComponent";
    import ProductFunction from "../../commom/ProductFunction";
    import ProductInfo from "../../commom/ProductInfo";
    export default {
        name: "cicada",
        components: {VideoComponent, VideoComponent1, ProductFunction,ProductInfo},
        mounted() {
            this.$nextTick(()=>{
                this.$http
                    .all([
                        this.$http.get("Cases/GetCasesAll"),
                        this.$http.get(`News?type=1&num=3`)
                    ])
                    .then(
                        this.$http.spread((responseCases, responseNews) => {
                            if(this.$route.hash){
                                let dom =  document.querySelector(this.$route.hash);
                                console.log(dom)
                                dom.scrollIntoView();
                            }

                        })
                    );


            })
        }
    }
</script>

<style scoped>

</style>